<template>
  <div class="container-single-enum-multiple">
   ROLA
  </div>
</template>

<script>
export default {
  name: 'SingleEnumMultiple',
  status: 'prototype',
  release: '1.0.0',
  props: {
    value: {
      required: true
    },
    bgColor: {
      type: String
    },
    hoverColor: {
      type: String
    },
    textColor: {
      type: String
    },
    labelColor: {
      type: String
    },
    items: {
      type: Array
    },
    itemValue: {
      type: String
    },
    itemText: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      screenX: '',
      options: []
    }
  },
  mounted () {
    this.screenX = window.screen.availWidth

    const responseOnLoad = this.options.find(e => e.rating.toString() === this.rating)

    if (responseOnLoad) {
      setTimeout(() => {
        this.selectOption(responseOnLoad, `.op-${responseOnLoad.rating}${this.questionId}`)
      }, 10)
    }
  },
  methods: {
    selectOption (e, btnClass) {
      const buttons = document.querySelectorAll(`.is-${this.questionId}`)

      for (const child of buttons) {
        child.style.borderColor = 'transparent'
        child.style.transform = 'scale(1)'
        child.style.fontSize = '1.5rem'
      }

      const selectedButton = document.querySelector(btnClass)

      selectedButton.style.borderColor = '#000000'
      selectedButton.style.transform = 'scale(1.020)'
      selectedButton.style.fontSize = '1.6rem'

      return this.$emit('isValue', e.rating)
    }
  }
}
</script>

<style lang="scss" scoped>
:root { font-size: 62.5%; }

.container-single-matrix-5-num {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .btn-matrix-5-num-single {
    width: 23rem;
    height: 4.5rem;
    margin: 0.8rem 0;
    border-radius: 3.5rem;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: bold;
    border: 0.15rem solid transparent;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    box-shadow: 0 5px 15px 0 #d7d7d7;
    background-image: linear-gradient(
      -60deg,
      transparent, transparent 40%,
      #ffffff44 40%, #ffffff44 60%,
      transparent 60%, transparent 100%
    ) !important;
    background-size: 200% 100% !important;
    background-repeat: no-repeat !important;
    background-position-x: 150% !important;
  }
  .btn-matrix-5-num-single:hover {
    transform: scale(1.020);
    background-position-x: -150% !important;
    transition: background-position-x 1s !important;
  }
}

@media only screen and (max-width: 500px) {
  .container-single-matrix-5-num {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    .btn-matrix-5-num-single {
      width: 7rem;
      height: 5.5rem;
      margin: 0 0.3rem;
      margin-bottom: 10px;
      font-size: 1rem;
    }
  }
}
</style>
